import { AxiosInstance } from "axios";
import CommonCRUD from "modules/CommonCRUD";

class EmployeesJournal extends CommonCRUD {}

export default EmployeesJournal;
